<template>
   <transition name="modal-fade">
   <div class="modal-backdrop" v-on:click="detect_target">
      <div class="modal-container">
         <header class="modal-header">
            <button type="button" class="eui-btn--blue" v-on:click="close_modal">close</button>
         </header>
         <section class="modal-body">
         <h2 v-if="science_keyword_modal_data['measurements'] != undefined">
            <span>{{science_keyword_modal_data['measurements']['Category']}} > </span>
            <span>{{science_keyword_modal_data['measurements']['Topic']}} > </span>
            <span>{{science_keyword_modal_data['measurements']['Term']}} > </span>
            <span>{{science_keyword_modal_data['measurements']['VariableLevel1']}}</span>
         </h2>
         <table class="dataset-table">
            <thead>
               <th>Dataset Name</th>
               <th>Concept ID</th>
               <th>Processing Level</th>
               <th>Start Date</th>
               <th>End Date</th>
               <th>Temporal Resolution</th>
            </thead>
            <tbody>
               <tr>
               <td colspan="4" v-if="science_keyword_modal_data['datasets'].length == 0">No Datasets.</td>
               </tr>
               <tr v-for="(dataset, index) in science_keyword_modal_data['datasets']" :key="index" :class="td_alternate_class(index)">
                  <td class="name"><span v-if="dataset_url(dataset)"><a :href="dataset_url(dataset)" target="_blank">{{datasetFieldValue(dataset,['EntryTitle'])}}</a></span><span v-else>{{datasetFieldValue(dataset,['EntityTitle'])}}</span><span v-if="datasetFieldValue(dataset,['ShortName'])"><br/>({{datasetFieldValue(dataset,['ShortName'])}})</span></td>
                  <td class="concept-id">{{dataset['meta']['concept-id']}}</td>
                  <td class="processing-level">
                     {{datasetFieldValue(dataset,['ProcessingLevel','Id'])}}
                  </td>
                  <td class="temporal_start">
                     <div v-html="dataset_temporal_output(datasetFieldValue(dataset,['TemporalExtents']), 'start')" />
                  </td>
                  <td class="temporal_end">
                     <div v-html="dataset_temporal_output(datasetFieldValue(dataset,['TemporalExtents']), 'end')" />
                  </td>
                  <td class="latency">
                     <div v-if="datasetFieldValue(dataset,['TemporalKeywords']) != undefined && datasetFieldValue(dataset,['TemporalKeywords'])[0] != undefined">
                        {{datasetFieldValue(dataset,['TemporalKeywords'])[0]}}
                     </div>
                  </td>
               </tr>
            </tbody>
         </table>
         </section>
         <footer class="modal-footer">
            <button type="button" class="eui-btn--blue" v-on:click="close_modal">close</button>
         </footer>
      </div>
   </div>
   </transition>
</template>

<script>
import Vue from "vue";
import {mapState} from "vuex";
import datasets_processing from './mixins/datasets_processing';
import table_row_alternate_class from './mixins/table_row_alternate_class';

export default {
   name: 'datasets_modal',
   mixins: [table_row_alternate_class,datasets_processing],
   computed: {
      ...mapState([
         'science_keyword_modal_data',
         'capabilities'
      ])
   },
   methods: {
      close_modal: function() {
         this.$emit('close_modal','science_keyword_datasets');
      },
      detect_target: function(event) {
         if(event.srcElement.getAttribute('class') == 'modal-backdrop') this.close_modal();
      }
   }
}
</script>

<style>
   .modal-backdrop {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
   }
   .modal-container {
      background: #FFFFFF;
      box-shadow: 2px 2px 20px 1px;
      overflow-x: auto;
      display: flex;
      flex-direction: column;
      width: 80%;
      height: 70%;
   }
   .modal-fade-enter,
   .modal-fade-leave-active {
      opacity: 0;
   }

   .modal-fade-enter-active,
   .modal-fade-leave-active {
      transition: opacity .5s ease
   }
</style>